import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EventSeatIcon(props: IconProps) {
    return <Icon {...props} iconKey={"event_seat"}/>
}
